
export default {
  props: {
    schema: String
  }
}
